import api from '../../configuration/api'

export const files = {
  uploadImage: (data) => api.post('files/upload/image', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};
